import { getTeamLeaguesPlayersUseCase } from '@/domain/use-cases/get-team-leagues-players.use-case';
import { PlayerInfoResponse } from '@/entities';
import { Result } from '@/entities/Result';
import { SearchParams } from '@/infrastructure/network/data/team-leagues-players';

export const getTeamLeaguesPlayersController = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	searchParams: SearchParams
): Promise<Result<PlayerInfoResponse>> => {
	return getTeamLeaguesPlayersUseCase(organizationUuid, teamLeagueUuid, searchParams);
};
